import React from 'react';

import { Box, FieldSet, FormHelp, Heading, Legend } from '@zillow/constellation-10';

import SwitchWithTitle from './SwitchWithTitle';
import type { SwitchObject } from '../../models/Types';

type Props = {
  switches: Array<SwitchObject>;
  title?: string;
  legend: string;
  description?: string;
  noBottomMargin?: boolean;
  optional?: boolean;
};

export default function SwitchesWithTitle({
  switches,
  title,
  legend,
  description,
  noBottomMargin,
  optional,
}: Props): JSX.Element {
  return (
    <>
      {title && (
        <Heading level={3} css={{ textStyle: 'responsive.body-lg-bold' }}>
          {title}
        </Heading>
      )}
      <FieldSet
        optional
        legend={<Legend optional={optional}>{legend}</Legend>}
        description={description ? <FormHelp>{description}</FormHelp> : undefined}
      >
        {switches.map(
          (sw: SwitchObject, index): React.ReactNode => (
            <React.Fragment key={index}>
              <SwitchWithTitle {...sw} />
              {!(noBottomMargin && index === switches.length - 1) && <Box css={{ marginBottom: 'sm' }} />}
            </React.Fragment>
          ),
        )}
      </FieldSet>
    </>
  );
}
